var map = {
	"./benefits_equipment.svg": 1321,
	"./benefits_personal.svg": 1322,
	"./benefits_tests.svg": 1323,
	"./benefits_time.svg": 1324,
	"./calendar.svg": 1325,
	"./facebook.svg": 1326,
	"./instagram.svg": 1327,
	"./logo.svg": 1328,
	"./ok.svg": 1329,
	"./salons.svg": 1330,
	"./services.svg": 1331,
	"./specialist.svg": 1332,
	"./telegram-2.svg": 1033,
	"./telegram.svg": 1333,
	"./vk.svg": 1334,
	"./whatsapp-2.svg": 1034,
	"./whatsapp.svg": 1335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1320;